import { actionTypes } from "./actions";

export const initialState = {
  country: []
};

// ===========================|| COMMON REDUCER ||=========================== //

const countryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.COUNTRY_GET_REQUEST:
      return {
        ...state,
        isCountryLoading: true,
      };
    case actionTypes.COUNTRY_GET_RECEIVE:
      return {
        ...state,
        country: action.payload.map((dt, index) => ({ ...dt, id: index })),
        isCountryLoading: false,
      };
    case actionTypes.COUNTRY_GET_FAIL:
      return {
        ...state,
        isCountryLoading: false,
        isCountryFail: false,
      };
    default:
      return state;
  }
};

export default countryReducer;
